import { useState } from "react";
import styles from "./LockedFeature.module.css";
import { Badge } from "./Badge";
import { Button } from "./Button";
import { UpgradeModal } from "../theme/UpgradeModal";

/**
 * "Gradual Reveal" pattern: wraps a feature's normal content, and when the
 * theme doesn't have `feature` enabled, blurs/dims it behind a preview and
 * offers an upgrade prompt instead of just hiding the section outright --
 * lets Basic-theme users see what they're missing.
 */
export function LockedFeature({ enabled, featureLabel, children, previewText }) {
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (enabled) return children;

  return (
    <div className={styles.wrapper}>
      <div className={styles.preview} aria-hidden="true">
        {children}
      </div>
      <div className={styles.overlay}>
        <Badge tone="honey">Advanced</Badge>
        <p className={styles.text}>{previewText || `${featureLabel} is part of the Advanced theme.`}</p>
        <Button size="sm" onClick={() => setShowUpgrade(true)}>
          Unlock {featureLabel}
        </Button>
      </div>
      <UpgradeModal open={showUpgrade} onClose={() => setShowUpgrade(false)} highlightFeature={featureLabel} />
    </div>
  );
}
